/**
 * Environment detection utilities.
 * Determines if the application is running in production, staging, development, or local environment
 * based on hostname and runtime configuration.
 */
import { getRuntimeMode } from './runtime';

export type Environment = 'localhost' | 'development' | 'test' | 'qa' | 'uat' | 'production';

enum EnvUrlPattern {
  LOCAL = 'local',
  DEVELOPMENT = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PRODUCTION = 'app'
}

function getEnv(): Environment {
  if (process.env.NODE_ENV === 'test') {
    return 'test';
  }

  const host = window.location.host.toLowerCase();

  if (host.includes(EnvUrlPattern.QA)) {
    return 'qa';
  }
  if (host.includes(EnvUrlPattern.UAT)) {
    return 'uat';
  }
  if (host.includes(EnvUrlPattern.PRODUCTION)) {
    return 'production';
  }
  if (host.includes(EnvUrlPattern.DEVELOPMENT) || host.includes(EnvUrlPattern.LOCAL)) {
    return host.includes(EnvUrlPattern.LOCAL) ? 'localhost' : 'development';
  }

  return 'development';
}

function isDevelop(): boolean {
  return getEnv() === 'development';
}

function isProduction(): boolean {
  return getEnv() === 'production';
}

function isQA(): boolean {
  return getEnv() === 'qa';
}

function isEnv(env: Environment): boolean {
  return getEnv() === env;
}

export const isRunningLocally = (): boolean => {
  return getRuntimeMode() === 'localhost' || getEnv() === 'localhost';
};

export { getEnv, isDevelop, isProduction, isQA, isEnv };
